"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledBox = exports.MenuItemContent = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _theming = _interopRequireDefault(require("../../../../utils/theming"));

var _polished = require("polished");

var _Box = _interopRequireDefault(require("@match/react-component-library/components/Box"));

var _constants = require("@match/react-component-library/components/theme/constants");

var _Icon = _interopRequireDefault(require("@match/react-component-library/components/Icon"));

var _components = require("./components");

var MenuItemContent = function MenuItemContent(_ref) {
  var buttonClassName = _ref.buttonClassName,
      children = _ref.children,
      _ref$count = _ref.count,
      count = _ref$count === void 0 ? 0 : _ref$count,
      hideLabel = _ref.hideLabel,
      icon = _ref.icon,
      isSelected = _ref.isSelected,
      label = _ref.label,
      noSelectionUnderline = _ref.noSelectionUnderline,
      showMenuIndicatorDot = _ref.showMenuIndicatorDot;
  var menuCount = showMenuIndicatorDot ? 1 : count;
  var color = _constants.SEMANTIC_COLOR_NAME.LIGHT;
  var menuIcon = icon ? icon : 'active';
  var menuItemLabel = label || "".concat(icon) || '';
  return _react.default.createElement(StyledBox, {
    className: buttonClassName,
    center: true,
    flexDirection: "column",
    height: "100%",
    paddingTop: hideLabel ? _constants.SPACE.NONE : _constants.SPACE.SMALL,
    minWidth: 64
  }, !children && _react.default.createElement(_Box.default, {
    display: "inline-block",
    textAlign: "center"
  }, _react.default.createElement(_Box.default, {
    display: "inline-block",
    position: "relative"
  }, _react.default.createElement("div", null, _react.default.createElement(_components.MenuItemBadge, {
    count: menuCount,
    showMenuIndicatorDot: showMenuIndicatorDot
  }), _react.default.createElement(_Icon.default, {
    color: color,
    name: menuIcon,
    size: "small",
    "aria-hidden": true
  }))), _react.default.createElement(_Box.default, {
    textAlign: "center"
  }, _react.default.createElement(_components.MenuItemLabel, {
    hideLabel: hideLabel,
    label: menuItemLabel
  }))), children && children, !noSelectionUnderline && _react.default.createElement(Underline, {
    backgroundColor: isSelected ? _constants.SEMANTIC_COLOR_NAME.LIGHT : undefined,
    width: 64,
    height: 4
  }));
};

exports.MenuItemContent = MenuItemContent;
var Underline = (0, _theming.default)(_Box.default)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    borderRadius: "".concat(theme.radii.roundCorner1x, "px ").concat(theme.radii.roundCorner1x, "px 0 0")
  };
});
var StyledBox = (0, _theming.default)(_Box.default)(function (_ref3) {
  var _ref4;

  var theme = _ref3.theme;
  return _ref4 = {
    background: 'transparent'
  }, (0, _defineProperty2.default)(_ref4, ':focus', {
    background: "".concat((0, _polished.transparentize)(0.8, theme.palette.dark))
  }), (0, _defineProperty2.default)(_ref4, ':focus-visible', {
    background: (0, _polished.transparentize)(0.9, theme.palette.core1_100),
    boxShadow: "0 0 10px 3px ".concat((0, _polished.transparentize)(0.95, theme.palette.dark))
  }), (0, _defineProperty2.default)(_ref4, ':hover', {
    background: "".concat((0, _polished.transparentize)(0.9, theme.palette.dark))
  }), _ref4;
});
exports.StyledBox = StyledBox;